// Real client work, shared by the homepage carousel (WebPortfolio) and /projects.
// Only facts about what was built — no invented results or numbers.
// `slug` is the case study URL (/projects/<slug>) — client sites' footer credits
// can link there, so don't change a slug once it's live.
export const PROJECTS = [
  {
    id: 'sas',
    slug: 'sexual-assault-specialists',
    service: { label: 'Business & professional websites', href: '/websites/business' },
    name: 'Sexual Assault Specialists',
    description: 'A Sydney criminal defence firm’s site — moody, editorial, built to feel serious the moment it loads.',
    image: '/SexualAssaultSpecialists-hero.webp',
    srcSet: '/SexualAssaultSpecialists-hero-800.webp 800w, /SexualAssaultSpecialists-hero.webp 1400w',
    imageAlt: 'Sexual Assault Specialists legal defence site homepage',
    href: 'https://complexcriminaltrials.legal/',
    domain: 'complexcriminaltrials.legal',
    type: 'Law firm website',
    brief: 'A Sydney criminal defence practice needed a dedicated site for people facing sexual assault charges or a police investigation. It had to feel discreet and serious, and make it easy to reach a lawyer.',
    built: [
      'A dark, editorial design in rust and amber, with a full-screen hero',
      'Plain answers to the first questions people ask: before a charge, which courts, and how fees work',
      'A locked-down content security policy and fast, lightweight pages',
      'Search-ready structure so the firm can be found for the right terms',
    ],
  },
  {
    id: 'velasquez',
    slug: 'velasquez-legal',
    service: { label: 'Business & professional websites', href: '/websites/business' },
    name: 'Velasquez Legal',
    description: 'AVO support with a fork right at the top — Defendant or PINOP — so every visitor lands on advice that actually applies to them.',
    image: '/VelasquezLegal-hero.webp',
    srcSet: '/VelasquezLegal-hero-800.webp 800w, /VelasquezLegal-hero.webp 1400w',
    imageAlt: 'Velasquez Legal AVO support site homepage',
    href: 'https://domesticviolencespecialists.legal/',
    domain: 'domesticviolencespecialists.legal',
    type: 'Law firm website',
    brief: 'The same practice needed a site for Apprehended Violence Orders. The catch: visitors are on opposite sides. Some have been named in an AVO, others need protection, and each needs different advice.',
    built: [
      'A choice at the top of the page: Defendant or PINOP (person in need of protection)',
      'The advice, timeline and packages below change to match the side the visitor picked',
      'A clear, trustworthy look in crimson and charcoal over a Sydney Harbour hero',
      'A mobile-first layout that reads cleanly on a phone',
    ],
  },
]

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug)
